// Module
var code = "<button class=\"previous-button-desktop flat beigedark hollow\" aria-label=\"{{previousButtonLabel}}\" ng-click=\"onClick()\"><i class=\"previous-chevron fa fa-chevron-left\"></i></button>";
// Exports
export default code;